<template>
  <div class="search-form">
    <b-form onsubmit="return false">
      <b-input-group size="sm">
        <b-form-input
          @keyup.enter="query"
          type="search"
          v-model.trim="form.keyword"
          :placeholder="
            $l('INDEX.form_label_search_shipmentBatchBox') ||
              '合同号/零售商PO/进口商PO 搜索...'
          "
        />
        <b-input-group-append>
          <b-button-group slot="reference">
            <b-button variant="primary" size="sm" @click="query">
              <i class="fa fa-search" />
            </b-button>
          </b-button-group>
        </b-input-group-append>
      </b-input-group>
    </b-form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: { keyword: '' },
    }
  },
  created() {
    this.query()
  },
  methods: {
    query() {
      this.$emit('query', this.form)
    },
  },
}
</script>
<style lang="scss" scoped>
.search-form {
  padding-bottom: 10px !important;
}
</style>
